function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-locations-state_svg__filter0_d_961:34)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 33,
  width: 125,
  height: 81,
  rx: 1.532,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0085FF",
  fillOpacity: 0.1,
  d: "M64 40h55v7H64zM64 52h95v7H64z"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 39,
  r: 14,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44 48s6-7.714 6-12-2.923-6-6-6-6 1.714-6 6 6 12 6 12zm2-12a2 2 0 11-4 0 2 2 0 014 0z",
  fill: "#0085FF"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F5F7",
  d: "M64 64h79v40H64z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F5F7",
  d: "M64 64h79v40H64z"
});
var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-locations-state_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.35,
  x: 29,
  y: 61,
  width: 62,
  height: 21,
  rx: 1,
  fill: "#1CC982"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.35,
  width: 42,
  height: 21,
  rx: 1,
  transform: "matrix(-1 0 0 1 146 61)",
  fill: "#0085FF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M147 91a1 1 0 00-1-1h-41.962a1 1 0 00-.693.28l-14.556 13.999c-.649.624-.207 1.721.693 1.721H146a1 1 0 001-1V91z",
  fill: "#1CC982"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M89.125 91.734c.668-.618.231-1.734-.679-1.734H28a1 1 0 00-1 1v16.5a1 1 0 001 1h42.608a1 1 0 00.68-.266l17.837-16.5z",
  fill: "#0085FF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M119 76s3-3.857 3-6-1.461-3-3-3-3 .857-3 3 3 6 3 6zm1-6a1 1 0 11-2 0 1 1 0 012 0z",
  fill: "#E96873"
}));
var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-locations-state_svg__filter0_d_961:34",
  x: 36,
  y: 27,
  width: 141,
  height: 97,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_961:34"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_961:34",
  result: "shape"
})));
function SvgEmptyLocationsState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("mask", {
    id: "empty-locations-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 64,
    width: 79,
    height: 40
  }, _ref7), _ref8, _ref9);
}
export default SvgEmptyLocationsState;